import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, provide } from "vue";
import { useRouter } from "vue-router";
import { Tabs } from "tir-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'router-tabs',
  props: {
  isButton: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



provide("routerTabsIsButton", props.isButton);

const router = useRouter();
const routeFullPath = computed(() => router.currentRoute.value.fullPath);

const update = (value: string) => {
  router.push({ path: value });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['router-tabs', { 'is-button': __props.isButton }])
  }, [
    _createVNode(_unref(Tabs), {
      "model-value": routeFullPath.value,
      "onUpdate:modelValue": update
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", { currentTab: routeFullPath.value })
      ]),
      _: 3
    }, 8, ["model-value"])
  ], 2))
}
}

})